import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  doc,
  onSnapshot,
  Firestore,
  Unsubscribe
} from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { TranslateService } from '@ngx-translate/core';

import { environment } from '../../environments/environment';

@Component({
    selector: 'app-box-open',
    templateUrl: `./box-open.component${environment.componentAssetExt}.html`,
    styleUrl: `./box-open.component${environment.componentAssetExt}.scss`,
    standalone: false
})
export class BoxOpenComponent implements OnInit, OnDestroy {

  confirmation = false;
  inProgress = false;
  session: any;
  sessionId?: string;

  private unsubscribe?: Unsubscribe;

  constructor(
    private firestore: Firestore,
    private functions: Functions,
    private route: ActivatedRoute,
    translate: TranslateService
  ) {
    translate.use(translate.getBrowserLang() ?? translate.getFallbackLang() ?? 'en');
  }

  ngOnInit() {
    this.sessionId = this.route.snapshot.paramMap.get('sid')!;
    this.unsubscribe = onSnapshot(
      doc(this.firestore, `instances/${environment.instanceId}/sessions/${this.sessionId}`),
      snapshot => {this.session = snapshot.data();},
      error => console.error(error.message)
    );
  }

  ngOnDestroy(): void {
    this.unsubscribe?.();
  }

  askForConfirmation(): void {
    this.confirmation = true;
  }

  declineConfirmation(): void {
    this.confirmation = false;
  }

  async openBox(pickup: boolean) {
    this.inProgress = true;
    try {
      const response = await fetch(environment.smartbox.unauthLockerServicesURI, {
        body: JSON.stringify({
          service: pickup ? 'box-open-pickup' : 'box-open-only',
          openLinkId: this.session.openLinkId
        }),
        method: 'POST',
        headers: {'Content-Type': 'application/json'}
      }).catch(() => {return undefined;});

      if (response && !response.ok) {
        throw `${response.statusText}\n${await response.text()}`;
      }

      if (this.session.beforeFirstOpen) {
        await httpsCallable(this.functions, 'registerFirstOpen')({
          instanceId: environment.instanceId,
          sessionId: this.sessionId
        });
      }
      else if (pickup) {
        await httpsCallable(this.functions, 'endReservation')({
          instanceId: environment.instanceId,
          sessionId: this.sessionId
        });
      }
    }
    catch (error) {
      console.error(error);
    }
    finally {
      this.inProgress = false;
    }
  }
}
